import React, { useContext } from "react";
import { Drawer, IconButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import clsx from "clsx";
import PeopleIcon from "@mui/icons-material/People";
import Logo from "./Logo";
import TopBar from "./TopBar";
import AppNavList from "../common/AppNavList";
import HeaderContext from "../contexts/HeaderContext";
import { RiBankFill } from "react-icons/ri";
import { BiTask, BiTransferAlt } from "react-icons/bi";
import {
  FaDownload,
  FaFileInvoice,
  FaSearchDollar,
  FaSignature,
} from "react-icons/fa";
import { BsFillExclamationTriangleFill } from "react-icons/bs";
import { PiCurrencyDollarSimple } from "react-icons/pi";
import { MdDownload } from "react-icons/md";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
    },
    toolbar: {
      paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 8px",
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: "none",
    },
    title: {
      flexGrow: 1,
    },
    drawerPaper: {
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(10),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: "100vh",
      overflow: "auto",
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
    },
    fixedHeight: {
      height: 240,
    },
  };
});

const size = 25;
export default function SideNavigation() {
  const { header } = useContext(HeaderContext);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleDrawerClose = () => {
    setOpen(false);
  };
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const menu = {
    list: [
      {
        title: "Clients",
        to: "/organizations",
        icon: <RiBankFill size={size} />,
      },
      {
        title: "Quotations",
        to: "/quotations",
        icon: <PiCurrencyDollarSimple size={size} />,
      },
      {
        to: "/tasks",
        title: "Tasks",
        icon: <BiTask size={size} />,
      },
      {
        to: "/employees",
        title: "Employees",
        icon: <PeopleIcon />,
      },
      {
        to: "/expenses",
        title: "Expenses",
        icon: <FaSearchDollar size={size} />,
      },
      {
        to: "/bulkDownload",
        title: "Bulk Download",
        icon: <MdDownload size={size} />,
      },
      // {
      //   to: "/invoices",
      //   title: "Invoices",
      //   icon: <FaFileInvoice size={size} />,
      // },
      // {
      //   to: "/unpaid_invoices",
      //   title: "3M Unpaid Invs",
      //   icon: <BsFillExclamationTriangleFill size={size - 5} />,
      // },
      {
        to: "/income_and_rebate",
        title: "Summary",
        icon: <BiTransferAlt size={size} />,
      },
      // {
      //   to: "/contracts",
      //   title: "Contracts",
      //   icon: <FaSignature size={size - 5} />,
      // },
      {
        to: "/contract-invs",
        title: "Contacts Invs",
        icon: <FaFileInvoice size={size} />,
      },
    ],
  };

  return (
    <React.Fragment>
      <TopBar
        headerTitle={header}
        handleDrawerOpen={handleDrawerOpen}
        open={open}
      />
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
      >
        <div className={classes.toolbarIcon}>
          <div style={{ flexGrow: 1 }}>
            <Logo />
          </div>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        {/* <Divider /> */}
        <AppNavList list={menu.list} />
        <div style={{ borderBottom: "1px solid #00000020" }}></div>
      </Drawer>
    </React.Fragment>
  );
}
